import { useEffect, useState } from "react";

/**
 * Seconds elapsed since `startedAt` (epoch ms), ticking once a second while
 * `running` is true. Returns null when there's no usable start timestamp.
 *
 * Used as the progress card's honest fallback when no ETA is available: an
 * indefinite "Calculating…" reads as "frozen", whereas a climbing elapsed
 * counter shows the job is alive without inventing a prediction.
 */
export default function useElapsedSeconds(startedAt, running) {
  const valid = Number.isFinite(startedAt) && startedAt > 0;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!running || !valid) return undefined;
    // Resync immediately so a late mount doesn't show a stale first tick.
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [running, valid, startedAt]);

  if (!valid) return null;
  return Math.max(0, Math.floor((now - startedAt) / 1000));
}
